module.exports = __webpack_public_path__ + "static/15pc-off-bubble-2ba016be4597d06441ad31a61dc96d5b.svg";